import {useParams} from "react-router-dom";
import React, {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useFormik} from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";
import Image from "react-bootstrap/Image";
import CardHeader from "@material-ui/core/CardHeader";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import {categoriesUpdate, createNewUnofficialProduct, updateSupplierProduct, fetchTenantSuppliersAndCategories, fetchOfficialSupplierUnits} from "../AdminPagesCrud";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import AdminSnackbar from "../AdminSnackbar";
import NumberInput from "../../../components/NumberInput";

function EditOrAddProduct({product, setOpenProductForm, isNew, setIsNew, setShowSnackbar, showSnackbar,
                            setSelectedProduct, initialValues, supplierClients, intl}){

    const {id} = useParams();
    const [snackbarWarning, setSnackbarWarning] = useState(false)
    const [suppliers, setSuppliers] = useState([])
    const [categories, setCategories] = useState([])
    const [availableUnits, setAvailableUnits] = useState([])
    const [selectedUnits, setSelectedUnits] = useState(
        product.unitsOfMeasurement && Array.isArray(product.unitsOfMeasurement) && product.unitsOfMeasurement.length > 0
            ? product.unitsOfMeasurement
            : []
    )
    const [defaultUnitId, setDefaultUnitId] = useState(
        product.defaultUnitOfMeasurement && product.defaultUnitOfMeasurement.uomId
            ? product.defaultUnitOfMeasurement.uomId
            : (product.unitsOfMeasurement && Array.isArray(product.unitsOfMeasurement) && product.unitsOfMeasurement.length > 0
                ? product.unitsOfMeasurement[0].uomId
                : null)
    )
    const [storeCode, setStoreCode]= useState(product.productCategory ? product.productCategory[0].storeCode : "")
    
    // Determine if product is external
    const isExternalProduct = product.isExternal === true || (isNew && product.isOfficial !== true)
    console.log("isExternalProduct:", isExternalProduct)
    console.log("=== END INITIALIZATION ===")


    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(product.imagePath);

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    useEffect(() => {
        fetchTenantSuppliersAndCategories(accessToken).then(response => {
    
            console.log("Suppliers And Categories: ", response)
            setSuppliers(response.data.suppliers)
            setCategories(response.data.categories)
    
        }).catch(error => console.log(error))
        
        // Fetch available units if external product
        if (isExternalProduct) {
            fetchOfficialSupplierUnits(accessToken).then(response => {
                setAvailableUnits(response.data || [])
            }).catch(error => {
                console.log("Error fetching units: ", error)
                setAvailableUnits([])
            })
        }
      }, [  ])

    const productInfoSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        sku: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        description: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        price: Yup.number()
            .typeError("Price must be a number") // for non-numeric input
            .positive("Price must be greater than 0")
            .min(0.01, "Minimum price is 0.01")
            .max(999999.99, "Maximum price is 999999.99")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        setFile(selected);
        setPreviewUrl(URL.createObjectURL(selected));
      };
    
    // const handleUpload = async () => {
    //     if (!file) return;
    
    //     const formData = new FormData();
    //     formData.append('image', file);
    
    //     try {
    //         const res = await axios.post('http://localhost:8200 /upload', formData, {
    //             headers: { 'Content-Type': 'multipart/form-data' },
    //         });
    //         alert('Upload successful!');
    //         console.log(res.data.image.url);
    //     } catch (error) {
    //         console.error('Upload failed:', error);
    //     }
    // };

    const handleCategoryChange = (categoryId) => {
        const selectedCategory = categories.find(cat => cat._id == categoryId)
        if(selectedCategory){
            formik.setFieldValue("categoryId", categoryId)
            setStoreCode(selectedCategory.storeCode)
        }
    }

    const handleCancel = () => {
        setSelectedProduct(initialValues)
        setOpenProductForm(false);
        setIsNew(true);
    }

    // Handle unit selection/deselection
    const handleUnitToggle = (unit) => {
        const unitData = {
            uomId: unit._id.toString(),
            name: unit.name,
            conversionFactor: 1,
            ...(unit.wmsId && { wmsId: unit.wmsId })
        }
        
        const isSelected = selectedUnits.some(u => u.uomId === unitData.uomId)
        
        if (isSelected) {
            // Remove unit
            const updated = selectedUnits.filter(u => u.uomId !== unitData.uomId)
            setSelectedUnits(updated)
            
            // If removed unit was default, set first remaining as default
            if (defaultUnitId === unitData.uomId) {
                setDefaultUnitId(updated.length > 0 ? updated[0].uomId : null)
            }
        } else {
            // Add unit
            setSelectedUnits([...selectedUnits, unitData])
            // If no default set, make this the default
            if (!defaultUnitId) {
                setDefaultUnitId(unitData.uomId)
            }
        }
    }

    // Handle conversion factor change
    const handleConversionChange = (uomId, conversionFactor) => {
        const updated = selectedUnits.map(u => {
            if (u.uomId === uomId) {
                // Parse to number, defaulting to 1 if empty or invalid
                const numValue = parseFloat(conversionFactor);
                // If invalid or empty, default to 1 (1 unit = 1 base unit)
                const finalValue = (conversionFactor === '' || isNaN(numValue)) ? 1 : numValue;
                return { ...u, conversionFactor: finalValue };
            }
            return u;
        });
        setSelectedUnits(updated)
    }

    // Handle default unit change
    const handleDefaultUnitChange = (uomId) => {
        setDefaultUnitId(uomId)
    }

    const formik = useFormik({
        initialValues: product,
        validationSchema: productInfoSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                // Validate units for external products
                if (isExternalProduct) {
                    if (selectedUnits.length === 0) {
                        alert("Please select at least one unit of measurement");
                        return;
                    }
                    if (!defaultUnitId) {
                        alert("Please select a default unit of measurement");
                        return;
                    }
                    // Validate conversion factors
                    const invalidUnits = selectedUnits.filter(u => {
                        const factor = u.conversionFactor;
                        // Convert to number if it's a string
                        const numFactor = typeof factor === 'string' ? parseFloat(factor) : Number(factor);
                        // Check if it's undefined, null, NaN, or <= 0
                        const isInvalid = numFactor === undefined || numFactor === null || isNaN(numFactor) || numFactor <= 0;
                        if (isInvalid) {
                            console.log("Invalid unit found:", {
                                unit: u.name,
                                uomId: u.uomId,
                                conversionFactor: factor,
                                type: typeof factor,
                                parsed: numFactor,
                                isNaN: isNaN(numFactor)
                            });
                        }
                        return isInvalid;
                    });
                    if (invalidUnits.length > 0) {
                        console.log("Invalid units count:", invalidUnits.length);
                        alert("All conversion factors must be greater than 0");
                        return;
                    }
                }

                // Prepare submission data
                const submissionData = {
                    ...values,
                    ...(isExternalProduct && {
                        unitsOfMeasurement: selectedUnits,
                        defaultUnitOfMeasurement: selectedUnits.find(u => u.uomId === defaultUnitId) || selectedUnits[0]
                    })
                }

                if(isNew){
                    createNewUnofficialProduct(submissionData, file, accessToken).then((response) => {
                        setOpenProductForm(false);
                        setIsNew(true);
                        setSelectedProduct(initialValues)
                        
                        // setShowSnackbar(!showSnackbar)
                    })
                }
                else{
                    // console.log("Update Item: ", product)
                    updateSupplierProduct(submissionData, file, accessToken).then((response) => {
                        setOpenProductForm(false);
                        setIsNew(true);
                        setSelectedProduct(initialValues)
                        
                    })
                }

            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }

        },
    });

    return (
        <>
            <Card>
                {!isNew ? <CardHeader title="Edit Product"/> : <CardHeader title="New Product"/> }
                <CardBody>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12 mb-8">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Product Name</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="name"
                                                        {...formik.getFieldProps("name")}
                                                    />
                                                    {formik.touched.name && formik.errors.name ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.name}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="sku">SKU</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="sku"
                                                        {...formik.getFieldProps("sku")}
                                                    />
                                                    {formik.touched.sku && formik.errors.sku ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.sku}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Description</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="name"
                                                        {...formik.getFieldProps("description")}
                                                    />
                                                    {formik.touched.description && formik.errors.description ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.description}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Supplier</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="supplier" id="supplier"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...formik.getFieldProps("supplierId")}
                                                        />}
                                                    >
                                                        {suppliers.map(s => {
                                                                return (
                                                                    <MenuItem value={s._id}>{s.entityName}</MenuItem>
                                                                )
                                                            }
                                                        )}
                                                    </Select>
                                                    {formik.touched.supplierId && formik.errors.supplierId ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.supplierId}</div>
                                                        </div>
                                                    ) : null}
                                                </div> 
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Category</InputLabel>
                                                    <Select
                                                        onChange={(e) => handleCategoryChange(e.target.value)}
                                                        input={<FilledInput name="categoryId" id="categoryId"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...formik.getFieldProps("categoryId")}
                                                        />}
                                                    >
                                                        {categories.map(c => {
                                                                return (
                                                                    <MenuItem value={c._id}>{c.name}</MenuItem>
                                                                )
                                                            }
                                                        )}
                                                    </Select>
                                                    {formik.touched.categoryId && formik.errors.categoryId ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.categoryId}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="storeCode">Store Code</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="storeCode"
                                                        value={storeCode}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                            {isExternalProduct ? (
                                                <>
                                                    <Grid item xs={12}>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <InputLabel>Units Of Measurement</InputLabel>
                                                        </div>
                                                    </Grid>
                                                    {availableUnits.length === 0 ? (
                                                        <Grid item xs={12}>
                                                            <div>No units available. Please ensure the official supplier has units configured.</div>
                                                        </Grid>
                                                    ) : (
                                                        availableUnits.map(unit => {
                                                            const isSelected = selectedUnits.some(u => u.uomId === unit._id.toString())
                                                            const selectedUnit = selectedUnits.find(u => u.uomId === unit._id.toString())
                                                            
                                                            return (
                                                                <Grid item xs={4} key={unit._id}>
                                                                    <div style={{ border: '1px solid #e0e0e0', borderRadius: '4px', padding: '12px', marginTop: '8px', height: '100%' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={isSelected}
                                                                                    onChange={() => handleUnitToggle(unit)}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={unit.name}
                                                                        />
                                                                        {isSelected && (
                                                                            <div style={{ marginTop: '8px' }}>
                                                                                <div style={{ marginBottom: '8px' }}>
                                                                                    <InputLabel style={{ fontSize: '12px' }}>Conversion Factor:</InputLabel>
                                                                                    <NumberInput
                                                                                        min="0.01"
                                                                                        step="0.01"
                                                                                        value={selectedUnit ? selectedUnit.conversionFactor : 1}
                                                                                        onChange={(e) => handleConversionChange(unit._id.toString(), e.target.value)}
                                                                                        className="form-control form-control-solid h-auto py-2 px-6"
                                                                                        style={{ width: '100%' }}
                                                                                    />
                                                                                </div>
                                                                                <FormControl component="fieldset">
                                                                                    <RadioGroup
                                                                                        value={defaultUnitId}
                                                                                        onChange={(e) => handleDefaultUnitChange(e.target.value)}
                                                                                    >
                                                                                        <FormControlLabel
                                                                                            value={unit._id.toString()}
                                                                                            control={<Radio size="small" />}
                                                                                            label="Set as Default Unit"
                                                                                        />
                                                                                    </RadioGroup>
                                                                                </FormControl>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Grid>
                                                            )
                                                        })
                                                    )}
                                                </>
                                            ) : (
                                                <Grid item xs={4}>
                                                    <div className="form-group fv-plugins-icon-container">
                                                        <InputLabel>Units Of Measurement (Read Only)</InputLabel>
                                                        <div style={{ padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                                            {product.unitsOfMeasurement && Array.isArray(product.unitsOfMeasurement) && product.unitsOfMeasurement.length > 0 ? (
                                                                <div>
                                                                    <div><strong>Default:</strong> {product.defaultUnitOfMeasurement?.name} ({product.defaultUnitOfMeasurement?.conversionFactor})</div>
                                                                    <div style={{ marginTop: '8px' }}>
                                                                        <strong>All Units:</strong>
                                                                        <ul style={{ margin: '4px 0', paddingLeft: '20px' }}>
                                                                            {product.unitsOfMeasurement.map(uom => (
                                                                                <li key={uom.uomId}>{uom.name} ({uom.conversionFactor})</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div>No units configured</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Grid>
                                            )}
                                            {/* <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="unitMeasurement">Unit Of Measure</InputLabel>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="unitMeasurement"
                                                        {...formik.getFieldProps("unitMeasurement")}
                                                    />
                                                    {formik.touched.unitMeasurement && formik.errors.unitMeasurement ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.unitMeasurement}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid> */}
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="lastPoCost">Last PO Cost</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="lastPoCost"
                                                        {...formik.getFieldProps("lastPoCost")}
                                                    />
                                                    {formik.touched.lastPoCost && formik.errors.lastPoCost ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.lastPoCost}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="latestLandedCost">Latest Landed Cost</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="latestLandedCost"
                                                        {...formik.getFieldProps("latestLandedCost")}
                                                    />
                                                    {formik.touched.latestLandedCost && formik.errors.latestLandedCost ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.latestLandedCost}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="lowerPriceMargin">Lower Price Margin</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="lowerPriceMargin"
                                                        {...formik.getFieldProps("lowerPriceMargin")}
                                                    />
                                                    {formik.touched.lowerPriceMargin && formik.errors.lowerPriceMargin ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.lowerPriceMargin}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="price">Price</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="price"
                                                        {...formik.getFieldProps("price")}
                                                    />
                                                    {formik.touched.price && formik.errors.price ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.price}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="discountPrice">Discount Price</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="discountPrice"
                                                        {...formik.getFieldProps("discountPrice")}
                                                    />
                                                    {formik.touched.discountPrice && formik.errors.discountPrice ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.discountPrice}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="fob">FOB c/u</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="fob"
                                                        {...formik.getFieldProps("fob")}
                                                    />
                                                    {formik.touched.fob && formik.errors.fob ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.fob}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Comment</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="comment"
                                                        {...formik.getFieldProps("comment")}
                                                    />
                                                    {formik.touched.comment && formik.errors.comment ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.comment}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Is Active</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="isActive" id="isActive"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...formik.getFieldProps("isActive")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {formik.touched.isActive && formik.errors.isActive ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.isActive}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Assign Stores</InputLabel>
                                                    <Select
                                                        multiple
                                                        value={formik.values.exclusiveStoreIds}
                                                        onChange={(e) => formik.setFieldValue("exclusiveStoreIds", e.target.value)}
                                                        input={
                                                            <FilledInput
                                                            name="exclusiveStoreIds"
                                                            id="exclusiveStoreIds"
                                                            className="form-control form-control-solid h-2 py-2 px-6"
                                                            />
                                                        }
                                                        renderValue={(selected) =>
                                                            supplierClients
                                                            .filter(client => selected.includes(client._id.toString()))
                                                            .map(client => client.businessName)
                                                            .join(', ')
                                                        }
                                                        >
                                                        {supplierClients.map(client => (
                                                            <MenuItem key={client._id} value={client._id.toString()}>
                                                                {client.businessName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </Grid>
                                            <div>
                                                <input type="file" onChange={handleFileChange} />
                                                {previewUrl && <img src={previewUrl} alt="Preview" style={{ width: 400 }} />}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className="col-12 row justify-content-center">
                                    <button className="btn btn-primary" type="submit">
                                        Save
                                    </button>
                                    <div className="pl-4"/>
                                    <button className="btn btn-secondary" type="button" onClick={() => handleCancel()}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </CardBody>
            </Card>
            <AdminSnackbar
                message={'The selected supplier does not have any categories. Select another one or Cancel.'}
                setShowSnackbar={setSnackbarWarning}
                showSnackbar={snackbarWarning}
                variant={'warning'}
            />
        </>
    )
}

export default injectIntl(EditOrAddProduct);
